export default __webpack_public_path__ + "static/media/green5en.b422a0cf.jpg";